import React, { useContext, useState, createContext, useEffect } from 'react'

import useCache from './CacheProvider'
import ConfigService from 'services/ConfigService'

const ConfigContext = createContext('config')

export const ConfigContextProvider = ({ children }) => {
  const { getCache } = useCache()
  const [config, setConfig] = useState(
    getCache('CONFIG', {
      sliders: null,
      banners: [],
      categories: [],
      topCategories: [],
      footer: [],
      settings: {},
      topBar: {},
      translate: {},
      isLoaded: false,
    })
  )
  const [isLoaded, setLoaded] = useState(Boolean(config.isLoaded))

  useEffect(() => {
    ConfigService.getConfig()
      .then(coreConfig => {
        setConfig(prevConfig => ({
          ...prevConfig,
          ...coreConfig,
        }))
        setLoaded(true)

        ConfigService.getCategories()
          .then(categoriesData => {
            setConfig(prevConfig => ({
              ...prevConfig,
              categories: categoriesData.categories,
            }))
          })
          .catch(error => {
            console.error('Error fetching categories:', error)
          })

        ConfigService.getTopCategories()
          .then(topCategoriesData => {
            setConfig(prevConfig => ({
              ...prevConfig,
              topCategories: topCategoriesData.topCategories,
            }))
          })
          .catch(error => {
            console.error('Error fetching top categories:', error)
          })
      })
      .catch(error => {
        console.error('Error fetching initial core config:', error)
      })
  }, [])

  const getBanners = (position, count) => {
    if (!Array.isArray(config.banners)) return []

    if (count === 'all') {
      const banner = config.banners.filter(item => item.position === position)
      return banner || []
    }

    return config.banners.find(item => item.position === position)
  }

  return (
    <ConfigContext.Provider
      value={{
        sliders: config.sliders,
        categories: config.categories,
        topCategories: config.topCategories,
        footer: config.footer,
        translate: config.translate,
        settings: config.settings,
        topBar: config.topBar,
        isLoaded: isLoaded,
        getBanners: getBanners,
      }}
    >
      {children}
    </ConfigContext.Provider>
  )
}

const useConfig = () => useContext(ConfigContext)

export default useConfig
